var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("default-item", {
    staticClass: "menu--item-oceano_default",
    attrs: {
      item: _vm.item,
      "show-bin": _vm.showBin,
      "pricing-types": _vm.pricingTypes,
      "is-grouped-by-price": _vm.isGroupedByPrice,
      "tag-location": _vm.tagLocation,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }